import React, { ReactNode } from 'react'

import {
  AskYogiAnywhereProvider,
  NavProvider,
  TopBarProvider,
} from 'features/project/partials/project-layout/contexts'

/**
 * Combined provider that composes all layout-related contexts.
 * This provides a single provider component for the entire layout state management.
 */
export const LayoutProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  return (
    <NavProvider>
      <AskYogiAnywhereProvider>
        <TopBarProvider>{children}</TopBarProvider>
      </AskYogiAnywhereProvider>
    </NavProvider>
  )
}
